class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // const url = new URL(window.location);
    // if (url.searchParams.has('variant')) {
    //   this._setPDPDirty();
    // } else {
    //   this._setPDPClean();
    // }

    this.addEventListener("variant:changed", (e) => {
      this._setPDPDirty();

      const { variant } = e.detail;

      this._updateAtcs(variant);
      this._updateIdInputs(variant);
      this._updateBisButtons(variant);

      if (!variant) return;

      this._updatePrices(variant);
      this._updateUrl(variant);
      this._updateFinalSale();
    });

    this.form.addEventListener("submit", (e) => {
      const indeterminate = this.querySelector("[data-option-indeterminate]");

      if (!indeterminate) return;

      indeterminate.classList.add("error-shake");
      indeterminate.focus();
    });
  }

  disconnectedCallback() {}

  get atcs() {
    return this.querySelectorAll("[data-product-form-atc]");
  }

  get bisButtons() {
    return this.querySelectorAll("back-in-stock-button");
  }

  get prices() {
    return this.querySelectorAll("price-snippet");
  }

  get idInputs() {
    return this.querySelectorAll('input[name="id"]');
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }

  get finalSale() {
    return this.querySelector("[data-final-sale]");
  }

  get form() {
    return this.querySelector("form");
  }

  _updateAtcs(variant) {
    this.atcs.forEach((atc) => {
      atc.disabled = !variant || !variant.available;
    });
  }

  _updateBisButtons(variant) {
    this.bisButtons.forEach((button) =>
      button.setAttribute("selected-variant", variant.id),
    );
  }

  _updatePrices(variant) {
    this.prices.forEach((price) => {
      price.setAttribute("price", variant.price / 100);
      price.setAttribute("compare-at-price", variant.compare_at_price / 100);
      price.setAttribute("currency", window.Shopify.currency.active);
      price.setAttribute("dynamic", "");
    });
  }

  _updateIdInputs(variant) {
    this.idInputs.forEach((idInput) => {
      idInput.value = variant?.id || "";
    });
  }

  _updateUrl(variant) {
    const url = new URL(window.location);

    if (!window.Shopify.designMode && this.updateUrl) {
      url.searchParams.set("variant", variant.id);
      window.history.replaceState("", "", url);
    }
  }

  _updateFinalSale() {
    const url = new URL(window.location);

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const newFinalSale = html.querySelector("[data-final-sale]");

        if (!newFinalSale) return;
        this.finalSale.innerHTML = newFinalSale.innerHTML;
      });
  }

  _setPDPClean() {
    document.body.classList.add("pdp-clean");
  }

  _setPDPDirty() {
    document.body.classList.remove("pdp-clean");
    document.body.classList.add("pdp-dirty");
    this.querySelectorAll("[data-option-indeterminate]").forEach((el) => {
      delete el.dataset.optionIndeterminate;
    });
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
